import { Button, Flex, Form, Modal, Rate, Typography } from "antd"
import React, { useState } from "react"
import { TextArea } from "../Input/TextArea.tsx"

const { Title } = Typography
export interface SubcontractorRateFormData {
  rating: number
  comment: string
}

interface SubcontractorRateModalProps {
  visible: boolean
  onCancel: () => void
  onSubmit: (data: SubcontractorRateFormData) => void
}

export function SubcontractorRateModal({
  visible = true,
  onCancel,
  onSubmit
}: SubcontractorRateModalProps) {
  const [form] = Form.useForm<SubcontractorRateFormData>()
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (values: SubcontractorRateFormData) => {
    setLoading(true)
    try {
      await onSubmit?.(values)
      handleCancel()
    } catch (error) {
      console.error("Error submitting rating:", error)
    } finally {
      setLoading(false)
    }
  }

  function handleCancel() {
    form.resetFields()
    onCancel?.()
  }

  return (
    <Modal
      open={visible}
      onCancel={handleCancel}
      title={
        <Title level={3} style={{ textAlign: "left", margin: 0 }}>
          Rate Subcontractor Performance
        </Title>
      }
      maskClosable={false}
      centered={true}
      width={600}
      footer={null}
      styles={{
        content: {
          overflowY: "auto",
          maxHeight: "90vh"
        }
      }}
    >
      <div style={{ padding: "20px 0" }}>
        <Form<SubcontractorRateFormData>
          form={form}
          layout="vertical"
          validateTrigger={["onSubmit", "onChange"]}
          className={"with-default-error"}
          onFinish={handleSubmit}
          initialValues={{
            rating: 0,
            comment: ""
          }}
        >
          <div>
            <Form.Item<SubcontractorRateFormData>
              label={"Overall Rating"}
              name="rating"
              rules={[
                { required: true },
                {
                  validator: (_, value) => {
                    if (value && value > 0) return Promise.resolve()

                    return Promise.reject(new Error("Please provide a rating"))
                  }
                }
              ]}
            >
              <Rate
                allowHalf
                style={{ fontSize: "24px" }}
                tooltips={["Poor", "Fair", "Good", "Very Good", "Excellent"]}
              />
            </Form.Item>
          </div>
          <Form.Item<SubcontractorRateFormData>
            label={"Comments"}
            name="comment"
            rules={[
              // {
              //   required: true,
              //   message: "Please provide comments about the work"
              // },
              {
                min: 1,
                whitespace: true,
                message: "Comments must be at least 3 characters long"
              },
              {
                max: 100,
                message: "Comments must be at most 100 characters long"
              }
            ]}
          >
            <TextArea
              rows={4}
              placeholder="Please provide detailed feedback about the subcontractor's performance, quality of work, timeliness, communication, etc."
              maxLength={100}
              showCount
            />
          </Form.Item>

          <Flex gap={"middle"} justify={"end"} style={{ marginTop: "24px" }}>
            <Button onClick={handleCancel} disabled={loading}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              Submit Rating
            </Button>
          </Flex>
        </Form>
      </div>
    </Modal>
  )
}
